import React, { useState, useEffect } from 'react';
import Loading from '../Loading';
import { useLocation } from 'react-router-dom';
import { getVerify } from '../../api';
import { sendAgainEmailNotice, somethingWentWrongNotice } from '../UI/Notifications';

const SendAgain = () => {
  const [verifyData, setVerifyData] = useState({});
  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const queryParams = {};

    query.forEach(function (value, key) {
      queryParams[key] = value;
    });

    setVerifyData(queryParams);
  }, [setVerifyData]);
  
  const sendAgainHandler = () => {
    setLoading(true);
    getVerify(verifyData)
      .then(() => sendAgainEmailNotice())
      .catch(() => somethingWentWrongNotice("Email Verification"))
      .finally(() => setLoading(false));
  }

  return (
    <div className="form-wrap my-5 text-center">
      <h4 className="mb-5">Please check your email to activate
        your Match Force account and to verify your email address. 
      </h4>
      <span
        className="btnSizes filledBtn"
        onClick={sendAgainHandler}
      >
        Send Again
      </span>
      {loading && <Loading />}
    </div>
  )
}

export default SendAgain;